import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { registerSW } from 'virtual:pwa-register';
import App from './App';
import '@paulownia/shared/index.css';
import { Toaster } from 'sonner';
import { initFirebase, ErrorBoundary, TenantProvider, initSentry, reportWarning } from '@paulownia/shared';

// Initialize Sentry before anything else
initSentry('merchant');

// Register service worker with proper error handling
registerSW({
  onRegistered(registration) {
    if (registration) {
      console.log('Service worker registered successfully');
    }
  },
  onRegisterError(error) {
    // Report to Sentry with context but as warning (non-critical)
    reportWarning('Service worker registration failed', {
      error: error instanceof Error ? error.message : String(error),
      userAgent: navigator.userAgent,
    });
  },
});

try {
  initFirebase();
} catch (error) {
  console.error('Failed to initialize Firebase:', error);
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <TenantProvider>
          <App />
          <Toaster position="top-center" richColors />
        </TenantProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>
);
